import { useQuery, useMutation } from 'react-query'
import axios from 'axios'

const useReport = (params, enabled, prod = false) => useQuery(['report', params], async () => {
  const basePath = prod ? 'https://api.clikauto.com' : process.env.NEXT_PUBLIC_API_ROOT
  const url = params?.id
    ? `${basePath}/api/estimated_market_value/${params?.id}/report`
    : `${basePath}/api/estimated_market_value`

  const { data } = await axios.get(
    url,
    { params },

  )
  return data
}, {
  enabled,
  refetchOnWindowFocus: false,
  refetchOnmount: false,
  refetchOnReconnect: false,
  retry: false,
  staleTime: 1000 * 60 * 24,
})

const useReportMutation = () => useMutation(
  (params) => {
    const url = `${process.env.NEXT_PUBLIC_API_ROOT}/api/cotizations`
    if (params?.cotization_id) {
      return axios.put(`${url}/${params?.cotization_id}/`, params)
    }
    return axios.post(url, params)
  },
)

export { useReport, useReportMutation }
